<template>
  <div class="box-border px-4 space-y-3">
    <draggable :list="items" class="space-y-3" handle=".handle">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="group item box-border flex items-center w-full space-x-3 cursor-pointer bg-gray-100 px-4 py-3 rounded-3xl outline-solid-2"
        :class="{
          'outline-solid-purple-500': isEditMode && isActiveItem(item),
        }"
        @click="$emit('click-item', item)"
      >
        <div v-if="isEditMode" class="handle inline-flex cursor-pointer text-gray-500 transition-opacity opacity-0 group-hover:opacity-100">
          <Icon icon="ph:dots-six-vertical-bold" height="14" />
        </div>

        <div
          class="w-9 h-9 flex items-center justify-center flex-shrink-0 overflow-hidden"
          :class="{ 'rounded-full': Boolean(item.image) }"
        >
          <span
            v-if="item.emoji"
            class="text-4xl leading-none"
          >
            {{ item.emoji }}
          </span>
          <div v-else class="relative w-full h-full bg-gray-200 rounded-full" />
        </div>

        <p
          class="flex-1 text-base leading-5 font-medium m-0 whitespace-pre-line"
          :class="{ 'opacity-30': !Boolean(item.title) }"
        >
          {{ item.title || 'Без заголовка' }}
        </p>

        <div
          v-if="isEditMode"
          class="inline-flex cursor-pointer text-red-500 transition-opacity opacity-0 group-hover:opacity-100"
          @click.stop="$emit('delete-item', item)"
        >
          <Icon icon="ph:trash" height="14" />
        </div>
      </div>
    </draggable>

    <div
      v-if="isEditMode"
      class="group bg-gray-100 py-2 px-6 rounded-2xl flex justify-center cursor-pointer"
      @click="$emit('add')"
    >
      <Icon
        icon="ph:plus"
        width="24"
        class="transition-opacity opacity-20 group-hover:opacity-100"
      />
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { useMode } from '../composables/mode'

export default {
  components: { Draggable },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'view',
      validator: (val) => ['view', 'edit'].includes(val)
    },
    activeItem: {
      type: Object,
      default: null,
    }
  },
  setup(props) {
    const { isEditMode } = useMode(props)

    function isActiveItem(item) {
      if (props.activeItem == null) return false
      return Object.is(props.activeItem, item)
    }

    return {
      isEditMode,
      isActiveItem,
    }
  }
}
</script>